const BASE_URL = 'https://testseries.prrepxpathshala.live';
const DEFAULT_IMAGE = `${BASE_URL}/PrepXPathshala_logo2.jpg`;
const SITE_NAME = 'Test Series Portal - PrrepX Pathshala';

const pageMeta = {
  '/': {
    title: "PrrepX Pathshala Test Series — India's Best Test Series for JEE & NEET",
    description: 'Practice with the best test series for JEE Mains, JEE Advanced & NEET. Premium mock tests, PYQ papers with detailed solutions by IIT/NIT alumni.',
  },
  '/test-series': {
    title: "PrrepX Pathshala Test Series — India's Best Test Series for JEE & NEET",
    description: 'Practice with the best test series for JEE Mains, JEE Advanced & NEET. Premium mock tests, PYQ papers with detailed solutions by IIT/NIT alumni.',
  },
  '/inquiry-now': {
    title: 'Contact Us — Test Series Portal | PrrepX Pathshala',
    description: 'Have questions about our test series? Reach out to PrrepX Pathshala for help with JEE/NEET test packages and subscriptions.',
  },
  '/login': {
    title: 'Login — Test Series Portal | PrrepX Pathshala',
    description: 'Log in to your PrrepX Pathshala Test Series account to access premium mock tests, PYQ papers and track your performance.',
  },
  '/signup': {
    title: 'Sign Up — Test Series Portal | PrrepX Pathshala',
    description: 'Create your free PrrepX Pathshala account to access test series for JEE Mains, JEE Advanced and NEET.',
  },
  '/profile': {
    title: 'My Profile — Test Series Portal | PrrepX Pathshala',
    description: 'Manage your PrrepX Pathshala Test Series profile, view purchased tests and track your exam preparation progress.',
  },
  '/exam-guide': {
    title: 'Exam Guide — JEE & NEET Exam Information | PrrepX Pathshala',
    description: 'Complete guide for JEE Mains, JEE Advanced & NEET exams. Exam patterns, eligibility, important dates, and preparation tips.',
  },

  // Test Series Category Pages
  '/test-series/pyq': {
    title: 'Free PYQ Test Series — JEE & NEET Previous Year Papers | PrrepX Pathshala',
    description: 'Practice free previous year question papers for JEE Mains, JEE Advanced & NEET with timer, auto-scoring and detailed solutions.',
  },
  '/test-series/jee-premium': {
    title: 'JEE Premium Test Series — Mock Tests for JEE Mains & Advanced | PrrepX Pathshala',
    description: 'Premium JEE mock test series designed by IIT alumni. Full-length papers, chapter tests, and detailed performance analytics.',
  },
  '/test-series/neet-premium': {
    title: 'NEET Premium Test Series — Mock Tests for NEET-UG | PrrepX Pathshala',
    description: 'Premium NEET mock test series by top medical alumni. Full-length papers, subject-wise tests, and detailed performance analytics.',
  },

  // Free PYQ Series
  '/test-series/pyq/jeemains': {
    title: 'Free JEE Mains PYQ Tests — Previous Year Papers | PrrepX Pathshala',
    description: 'Practice free JEE Mains previous year question papers from 2019-2025. Year-wise and shift-wise with timer and solutions.',
  },
  '/test-series/pyq/jeeadv': {
    title: 'Free JEE Advanced PYQ Tests — Previous Year Papers | PrrepX Pathshala',
    description: 'Practice free JEE Advanced previous year question papers with detailed solutions. Paper 1 & Paper 2 with auto-scoring.',
  },
  '/test-series/pyq/neet': {
    title: 'Free NEET PYQ Tests — Previous Year Papers | PrrepX Pathshala',
    description: 'Practice free NEET previous year question papers from 2019-2025 with timer, auto-scoring and detailed solutions.',
  },

  // Purchased Tests
  '/purchased-tests': {
    title: 'My Purchased Tests — Test Series Portal | PrrepX Pathshala',
    description: 'Access your purchased premium test series. Take mock tests, view results and track your JEE/NEET preparation progress.',
  },

  // Admin
  '/admin': {
    title: 'Admin Dashboard — Test Series Portal | PrrepX Pathshala',
    description: 'Admin dashboard for managing test series, users and transactions on PrrepX Pathshala.',
  },
  '/admin/dashboard': {
    title: 'Admin Dashboard — Test Series Portal | PrrepX Pathshala',
    description: 'View analytics, user statistics and sales data for PrrepX Pathshala Test Series.',
  },
  '/admin/user-management': {
    title: 'User Management — Admin | PrrepX Pathshala Test Series',
    description: 'Manage users, view purchase history and handle user accounts on PrrepX Pathshala Test Series.',
  },
  '/admin/invoices': {
    title: 'Invoices — Admin | PrrepX Pathshala Test Series',
    description: 'View and manage payment invoices and transactions for PrrepX Pathshala Test Series.',
  },

  // Legal
  '/privacy-policy': {
    title: 'Privacy Policy — PrrepX Pathshala Test Series',
    description: "Read PrrepX Pathshala Test Series portal's privacy policy. Learn how we collect, use, and protect your personal information.",
  },
  '/terms-conditions': {
    title: 'Terms & Conditions — PrrepX Pathshala Test Series',
    description: "Read the terms and conditions for using PrrepX Pathshala's test series portal and services.",
  },
  '/refund-policy': {
    title: 'Refund & Cancellation Policy — PrrepX Pathshala Test Series',
    description: "Read PrrepX Pathshala's refund and cancellation policy for test series subscriptions and purchases.",
  },
  '/shipping-policy': {
    title: 'Shipping Policy — PrrepX Pathshala Test Series',
    description: "Read PrrepX Pathshala's shipping and delivery policy for test series materials and resources.",
  },
};

const defaultMeta = {
  title: "PrrepX Pathshala Test Series — India's Best Test Series for JEE & NEET",
  description: 'Practice with the best test series for JEE Mains, JEE Advanced & NEET. Premium mock tests, PYQ papers with detailed solutions by IIT/NIT alumni.',
};

export function getPageMeta(pathname) {
  const meta = pageMeta[pathname] || defaultMeta;
  return {
    title: meta.title,
    description: meta.description,
    image: meta.image || DEFAULT_IMAGE,
    url: `${BASE_URL}${pathname}`,
    siteName: SITE_NAME,
  };
}

export { pageMeta, defaultMeta, BASE_URL, DEFAULT_IMAGE, SITE_NAME };
